import React from "react";
import hairTreatmentImg from "./../../../../Images/HairSalonInnerPage/HAIR TREATMENT SERVICES.png";
const HairTreatmentImg = () => {
  return (
    <div className="haircutImg">
      <img src={hairTreatmentImg} alt="hairTreatmentImg" />
    </div>
  );
};

export default HairTreatmentImg;
